import React from 'react';

import OPComponent from './op_component';
import Navigation from '../../navigation';
import NavBar from '../../navbar';

/** Not used, but consider using this in future to test out the pattern, see if
 it makes things more concise, etc ***/

export default class Screen extends OPComponent {
  constructor(props) {
    super(props);
  }

  navigationButtonPressed = ({ buttonId }) => {
    if (NavBar.handleButtonPress2(buttonId, this)) return;
  };

  componentDidMount() {
    Navigation.registerForButtonEvents(this);

    if (this._instanceButtons) {
      Navigation.setButtons(this._instanceButtons, this.props.componentId);
    }
  }

  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
    this.props.onCloseScreen && this.props.onCloseScreen();
  }

  closeScreen = () => {
    Navigation.close(this.props);
  };
}
